<template>
	<div>
		<div v-if="!addOrEditReady">
			<LoadingSpinner class="col-12" />
		</div>
		<div v-else>
			<div class="mt-lg-4">
				<h3>3. {{ $t('pax.résultats') }}</h3>
			</div>

			<template v-if="criteres_local.length > 2 && Object.keys(recap).length > 0 && stallions_local.length > 0">
				<!-- <div class="paragraphes">{{ $t('pax.completer_caracterisation_jument') }} {{ criteres_remaining }} {{ $t('pax.criteres') }}.</div> -->
				<div v-if="!pax_express && show_suggestion" class="text-center mb-3"> 
					<a href="#" class="btn btn-pax" @click.prevent="goToSuggestion">{{ $t('pax.voir_suggestion_pax') }} <font-awesome-icon :icon="['far', 'angle-right']" /></a>
				</div>

				<div class="stallionGradeV2" v-for="stallion in stallions_local" :key="stallion.horse_id">
					<div class="row align-items-center" @click="showCompatibilite">
						<div class="col">
							<div :class="getGlobalColor(callColorGrade(stallion.horse_id), colorGeneticIndicator(stallion.horse_id))" class="stallionName">{{ stallion.horse_nom }}</div>
						</div>
						<div class="col-auto">
							<div :class="colorGeneticIndicator(stallion.horse_id)"  class="icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
						</div>
						<div class="col-auto">
							<div :class="callColorGrade(stallion.horse_id)" class="icon_pax"><font-awesome-icon :icon="['cf', 'puzzle']"/></div>
						</div>
					</div>
				</div>

				<b-alert v-if="show_mini_criteres_message" class="mt-2" show variant="warning">{{ $t('pax.mini_criteres_message') }}</b-alert>

				<!-- <div class="stallionGrade" v-for="stallion in stallions_local" :key="stallion.horse_id" :class="callColorGrade(stallion.horse_id)">
					<div class="row no-gutters align-items-center" @click="showCompatibilite">
						<div class="col-5">
							<div class="stallionName">{{ stallion.horse_nom }}</div>
						</div>
						<div class="col-7 text-center">
							<span class="bullet" v-for="critere in criteres_local" :class="getColorBullets(stallion.horse_id, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
						</div>
					</div>
				</div> -->
				<div class="text-right">
					<button class="btn btn-primary btn-next" @click="showCompatibilite">
						<template v-if="pax_express">{{ $t('pax.comparer_etalons') }}</template>
						<template v-else>{{ $t('pax.comparer_jusqua_3_etalons') }}</template> <font-awesome-icon :icon="['fal', 'long-arrow-right']" />
					</button>
				</div>
			</template>
			<template v-else>
				<div v-if="stallions_local.length == 0" class="closePopupCompatibilite">
					<template v-if="pax_express">
						{{ $t('pax.selectionner_stallion_compatibilite') }}
					</template>
					<template v-else>
						{{ $t('pax.selectionner_jusqua_stallion_compatibilite') }}
					</template>
				</div>
				<div v-else class="closePopupCompatibilite">{{ $t('pax.completer_criteres_voir_compatibilite') }}</div>
				<div class="blurry">
					<!-- {{ $t('pax.completer_caracterisation_jument') }} {{ criteres_remaining }} {{ $t('pax.criteres') }}. -->
					<div class="stallionGradeV2">
						<div class="row align-items-center">
							<div class="col">
								<div class="stallionName green">AIR JORDAN Z*GFE</div>
							</div>
							<div class="col-auto">
								<div class="green icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
							</div>
							<div class="col-auto">
								<div class="green icon_pax">
									<font-awesome-icon :icon="['cf', 'puzzle']"/>
								</div>
							</div>
						</div>
						<div class="row align-items-center">
							<div class="col">
								<div class="stallionName green">AIR JORDAN Z*GFE</div>
							</div>
							<div class="col-auto">
								<div class="green icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
							</div>
							<div class="col-auto">
								<div class="green icon_pax">
									<font-awesome-icon :icon="['cf', 'puzzle']"/>
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="stallionGrade mt-3"><div class="row no-gutters align-items-center"><div class="col-5"><div class="stallionName">AIR JORDAN Z*GFE</div></div><div class="col-7 text-center"><span class="bullet orange"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet green"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet red"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span></div></div></div>
					<div class="stallionGrade"><div class="row no-gutters align-items-center"><div class="col-5"><div class="stallionName">AIR JORDAN Z*GFE</div></div><div class="col-7 text-center"><span class="bullet orange"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet green"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet red"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span><span class="bullet"><font-awesome-icon :icon="['fas', 'circle']"/></span></div></div></div>
					<div class="text-right"><button class="btn btn-primary btn-next"><template v-if="pax_express">{{ $t('pax.comparer_etalons') }}</template><template v-else>{{ $t('pax.comparer_jusqua_3_etalons') }}</template> <font-awesome-icon :icon="['fal', 'long-arrow-right']" /></button></div> -->
				</div>
				<div v-if="stallions_local.length == 0 && (!isLg && !isXl)" class="text-left"><a href="#" class="btn btn-dark btn-back" @click.prevent="goToStallionSelection">{{ $t('pax.selectionner_stallion') }} <span class="icone"><font-awesome-icon :icon="['far', 'undo-alt']" /></span></a></div>
			</template>
		</div>

		<b-modal dialog-class="modal-pax" ref="modal" hide-footer id="paxModalSelection">
            <template v-slot:modal-title>
                {{ $t("pax.comparer_jusqua_3_etalons") }}
            </template>

        	<div v-for="(stallion, index) in stallions_selected" class="form-group" :key="'stallion_'+index">
				<label for="season">{{ $t('pax.stallion') }} {{ index+1 }}</label>
				<e-select
					v-model="stallions_selected[index]"
					track-by="horse_id"
					label="horse_nom"
					:placeholder="$t('pax.selectionner_un_stallion')"
					:options="stallions_selection_modal"
					:allow-empty="false"
					:show-labels="false"
					:sortable="false"
					:searchable="false"
				>
					<template slot="singleLabel" slot-scope="{ option }">
						<!-- <div class="stallionGrade" :key="option.horse_id" :class="callColorGrade(option.horse_id)">
							<div class="row no-gutters align-items-center" >
								<div class="col-5">
									<div class="stallionName">{{ option.horse_nom }}</div>
								</div>
								<div class="col-7 text-center">
									<span class="bullet" v-for="critere in criteres_local" :class="getColorBullets(option.horse_id, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
								</div>
							</div>
						</div> -->
						<div class="stallionGradeV2" :key="option.horse_id">
							<div class="row align-items-center" @click="showCompatibilite">
								<div class="col">
									<div :class="getGlobalColor(callColorGrade(option.horse_id), colorGeneticIndicator(option.horse_id))"  class="stallionName">{{ option.horse_nom }}</div>
								</div>
								<div class="col-auto">
									<div :class="colorGeneticIndicator(option.horse_id)" class="icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
								</div>
								<div class="col-auto">
									<div :class="callColorGrade(option.horse_id)" class="icon_pax">
										<font-awesome-icon :icon="['cf', 'puzzle']"/>
									</div>
								</div>
							</div>
						</div>
		            </template>
		            <template slot="option" slot-scope="{ option }">
						<!-- <div class="stallionGrade" :key="option.horse_id" :class="callColorGrade(option.horse_id)">
							<div class="row no-gutters align-items-center" >
								<div class="col-5">
									<div class="stallionName">{{ option.horse_nom }}</div>
								</div>
								<div class="col-7 text-center">
									<span class="bullet" v-for="critere in criteres_local" :class="getColorBullets(option.horse_id, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
								</div>
							</div>
						</div> -->
						<div class="stallionGradeV2" :key="option.horse_id">
							<div class="row align-items-center" @click="showCompatibilite">
								<div class="col">
									<div :class="getGlobalColor(callColorGrade(option.horse_id), colorGeneticIndicator(option.horse_id))" class="stallionName">{{ option.horse_nom }}</div>
								</div>
								<div  class="col-auto">
									<div :class="colorGeneticIndicator(option.horse_id)" class="icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
								</div>
								<div class="col-auto">
									<div :class="callColorGrade(option.horse_id)" class="icon_pax"><font-awesome-icon :icon="['cf', 'puzzle']"/></div>
								</div>
							</div>
						</div>
		            </template>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>

			<div class="text-center">
				<button class="btn btn-pax" @click="sendStallionsSelected">{{ $t('pax.comparer') }}</button>
			</div>
        </b-modal>

        <Suggestion ref="suggestion" :mare="mare" :stallions="stallions" :stallions_available="stallions_available" :criteres="criteres" :suggestion.sync="suggestion"/>
	</div>
</template>

<script type="text/javascript">
    import { EventBus } from 'EventBus'
	import Navigation from "@/mixins/Navigation.js"
	import PaxMixin from "@/mixins/Pax.js"
	import Tools from "@/mixins/Tools.js";
	import Window from '@/mixins/Window.js'
	import _cloneDeep from 'lodash/cloneDeep';


	export default {
		name: "ResultCompatibiliteHFull",
		props: {
			criteres: {
				type: Array,
				default: () => ( [] )
			},
			stallions: {
				type: Array,
				default: () => ( [] )
			},
			stallions_available: {
				type: Array,
				default: () => ( [] )
			},
			displayCompatibilite: {
				type: Boolean,
				default: () => (false)
			},
			mare: {
				type: Object,
				default: () => ( null )
			},
			pax_express: {
				type: Boolean,
				default: () => false
			},
		},
		mixins: [Navigation, PaxMixin, Tools, Window],
		data () {
			return {
				addOrEditReady: false,
				stallions_local: [],
				criteres_local: [],
				recap: {},
				stallions_selected: [null, null, null],
				suggestion: [],
				show_note: true,
				stallions_selection_modal: [],
				show_suggestion: true,
				genetic_indicators: [],
				compat_loading: false,
				genetic_loading: false,
				show_mini_criteres_message: false
			}
		},
		created() {
			this.init_component()
		},
		methods: {
			async init_component() {
				this.addOrEditReady = false

				this.stallions_local = _cloneDeep(this.stallions)

				this.addOrEditReady = true

				if(!this.pax_express) {
					setTimeout(() => this.show_note = false, 2000);
				}

				this.stallions_selection_modal = this.stallions_local

				this.criteres_local = _cloneDeep(this.criteres)
				this.calculCompatibilite()
				this.calculGeneticIndicator()
			},

			async calculCompatibilite() {
				this.compat_loading = true
				this.recap = await this.paxCalculCompatiblite(this.stallions_local, this.criteres_local)
				this.compat_loading = false
				this.show_mini_criteres_message = this.criteres_local.filter(critere => !!critere.slider).length < 11
			},

			async showCompatibilite() {
				if(this.stallions_local.length > 3) {
					this.$refs.modal.show()
					return false
				}
				this.$emit('update:step_label', "comparaison_V")
				this.$emit('update:stallions_comparaison', this.stallions_local)
				this.$emit('update:displayCompatibilite', true)
			},

			callColorGrade(stallion_id) {
				if(this.compat_loading) return 'genetic-loading'
				return this.colorGrade(stallion_id, this.recap, this.criteres_local)
			},

			goToStallionSelection() {
				this.$emit('update:step_label', "stallions")
			},

			sendStallionsSelected() {
				this.$refs.modal.hide()
				this.$emit('update:step_label', "comparaison_V")
				this.$emit('update:stallions_comparaison', this.stallions_selected)
				this.$emit('update:displayCompatibilite', true)
			},

			async goToSuggestion() {
				this.$refs.suggestion.openModal()
			},

			async savePanier() {
				if(this.mare && this.mare.horse_id && this.stallions_local.length > 0) {
					const stallions_ids = this.stallions_local.map(stallion => stallion.horse_id)
					await this.saveMarePanier(this.mare.horse_id, stallions_ids)
				}
			},

			async calculGeneticIndicator() {
				const stallions_ids = this.stallions_local.map(stallion => stallion.horse_id)
				if(!this.mare || stallions_ids.length == 0) return false
				this.genetic_loading = true
				this.genetic_indicators = await this.getGeneticIndicator(this.mare.horse_id, stallions_ids.join(','))
				this.genetic_loading = false
			},

			colorGeneticIndicator(stallion_id) {
				if(this.genetic_loading) return 'genetic-loading'
				return Object.prototype.hasOwnProperty.call(this.genetic_indicators, stallion_id) ? this.genetic_indicators[stallion_id].genetic_indicator_color : ''
			}
			
		},
		computed: {
			criteres_remaining() {
				let slider = this.criteres_local.filter(critere => critere.slider)
				return this.criteres_local.length - slider.length
			}
		},
		watch: {
			stallions(val) {
				this.stallions_local = _cloneDeep(val)
				this.stallions_selection_modal = _cloneDeep(val)
				this.calculCompatibilite()
				this.savePanier()
				this.calculGeneticIndicator()
			},
			'criteres': {
				deep: true,
				handler(val) {
					this.show_suggestion = true
					this.criteres_local = _cloneDeep(val)
					this.calculCompatibilite()
				}
			},
			'suggestion': {
				deep: true,
				handler(val) {
					this.show_suggestion = false
					this.$emit('update:suggestion', val)
				}
			},
			'stallions_selected': {
				deep: true,
				handler(val) {
					let ids = []
					val.forEach(stallion => {
						if(stallion && stallion.horse_id) {
							ids.push(stallion.horse_id)
						}
					})
					this.stallions_selection_modal = this.stallions_local.filter(stallion => !ids.includes(stallion.horse_id))
				}
			}
		},
		components: {
			LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
			Suggestion : () => import('@/components/Pax/Suggestion')
		}
	}
</script>
